import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import './App.css';
import 'react-bootstrap';
import "./css/Navbar.css";
import "./css/Footer.css";
import "./css/Pages.css";
import "./css/Contact.css";
import "./css/About.css";
import "./css/InvisibleCharacterGenerator.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

// import Header from './Components/Header';
// import Footer from './Components/Footer';
// import Home from "./Pages/Home";
// import About from "./Pages/About";
// import Blog from "./Pages/Blog";
// import Contact from "./Pages/Contact";
// import InvisibleCharacterGenerator from "./Pages/InvisibleCharacterGenerator";
import LangLayout from "./Layouts/LangLayout";


// ✅ LanguageWrapper to handle language changes
const LanguageWrapper = ({ children }) => {
  const { lang } = useParams(); // Get the language from the URL
  const { i18n } = useTranslation(); // Get i18n instance

  // Change language only when the route changes
  useEffect(() => {
    if (lang && i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return <>{children}</>;
};

// ✅ Redirect to English (`/en`) if no language is in the URL
const RedirectToDefaultLang = () => <Navigate to="/en" replace />;

function App() {
  return (
    <Router>
      <LanguageWrapper>
        {/* <Header /> */}
        <Routes>
          {/* Redirect root to default language */}
          <Route path="/" element={<RedirectToDefaultLang />} />

          {/* Nested routes under language */}
          <Route path="/:lang/*" element={<LangLayout />} />
        </Routes>
        {/* <Footer /> */}
      </LanguageWrapper>
    </Router>
  );
}

export default App;
